<form
  class="employee-executive-form"
  [formGroup]="formularioRegistro"
  novalidate
  (ngSubmit)="continuar()"
>
  <div class="employee-executive-profile">
    <span>Perfil:</span>
    <strong>{{ configuracionRegistro().perfilNombre }}</strong>
  </div>

  <section class="employee-executive-alert">
    <span class="employee-executive-alert__icon">
      <mat-icon>verified_user</mat-icon>
    </span>

    <div>
      <h2>Verificamos tu identidad para proteger tu cuenta</h2>
      <p>Tus datos están seguros con nosotros.</p>
    </div>
  </section>

  <section class="employee-executive-section">
    <header class="employee-executive-section__header">
      <mat-icon>lock</mat-icon>
      <h3>Datos de acceso</h3>
    </header>

    <div class="employee-executive-fields-card">
      <div
        class="employee-executive-field employee-executive-field--with-field-error"
        [class.employee-executive-field--invalid]="isInvalid('NumeroEmpleado')"
      >
        <label for="employee-executive-number">Número de empleado*</label>
        <input
          id="employee-executive-number"
          name="atlas-reg-employee-executive-number"
          type="text"
          inputmode="numeric"
          formControlName="NumeroEmpleado"
          placeholder="Ingresa tu número de empleado"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false"
        />

        @if (isInvalid("NumeroEmpleado")) {
          <button
            type="button"
            class="employee-executive-field__alert-button employee-executive-field__alert-button--field employee-executive-field__alert-button--error"
            aria-label="Ver error del número de empleado"
            (click)="abrirErrorCampo('NumeroEmpleado')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid("NumeroEmpleado")) {
          <small>{{ getError("NumeroEmpleado") }}</small>
        }
      </div>

      @if (configuracionRegistro().mostrarCuenta) {
        <div
          class="employee-executive-field employee-executive-field--with-field-error"
          [class.employee-executive-field--invalid]="isInvalid('Cuenta')"
        >
          <label for="employee-executive-account">
            {{ configuracionRegistro().etiquetaCuenta }}*
          </label>
          <input
            id="employee-executive-account"
            name="atlas-reg-employee-executive-account"
            type="text"
            formControlName="Cuenta"
            [placeholder]="configuracionRegistro().placeholderCuenta"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="characters"
            spellcheck="false"
          />

          @if (isInvalid("Cuenta")) {
            <button
              type="button"
              class="employee-executive-field__alert-button employee-executive-field__alert-button--field employee-executive-field__alert-button--error"
              aria-label="Ver error de la clave de Ejecutivo"
              (click)="abrirErrorCampo('Cuenta')"
            >
              <mat-icon>error_outline</mat-icon>
            </button>
          }

          @if (isInvalid("Cuenta")) {
            <small>{{ getError("Cuenta") }}</small>
          }
        </div>
      }

      <div
        class="employee-executive-field employee-executive-field--status"
        [class.employee-executive-field--invalid]="isInvalid('Usuario')"
      >
        <label for="employee-executive-user">Usuario*</label>
        <input
          id="employee-executive-user"
          name="atlas-reg-employee-executive-user"
          type="text"
          formControlName="Usuario"
          placeholder="Ingresa tu usuario"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false"
          maxlength="8"
        />

        <span class="employee-executive-field__status-action">
          @if (usuarioValido.pending) {
            <mat-icon
              class="employee-executive-field__status-icon employee-executive-field__status-icon--pending"
            >
              sync
            </mat-icon>
          } @else if (usuarioValido.is) {
            <mat-icon
              class="employee-executive-field__status-icon employee-executive-field__status-icon--success"
            >
              check_circle
            </mat-icon>
          } @else if (
            validacionUsuario && formularioRegistro.controls.Usuario.dirty
          ) {
            <button
              type="button"
              class="employee-executive-field__alert-button employee-executive-field__alert-button--error"
              aria-label="Ver error del usuario"
              (click)="abrirInfoUsuario()"
            >
              <mat-icon>error_outline</mat-icon>
            </button>
          } @else if (isInvalid("Usuario")) {
            <button
              type="button"
              class="employee-executive-field__alert-button employee-executive-field__alert-button--error"
              aria-label="Ver error del usuario"
              (click)="abrirErrorCampo('Usuario')"
            >
              <mat-icon>error_outline</mat-icon>
            </button>
          }
        </span>

        @if (isInvalid("Usuario")) {
          <small>{{ getError("Usuario") }}</small>
        }
      </div>

      <div
        class="employee-executive-field employee-executive-field--alias"
        [class.employee-executive-field--full]="
          !configuracionRegistro().mostrarCuenta
        "
        [class.employee-executive-field--invalid]="isInvalid('Alias')"
      >
        <label for="employee-executive-alias">Alias o sobrenombre*</label>
        <input
          id="employee-executive-alias"
          name="atlas-reg-employee-executive-alias"
          type="text"
          formControlName="Alias"
          placeholder="Ingresa tu alias"
          autocomplete="off"
          autocorrect="off"
          spellcheck="false"
        />

        @if (isInvalid("Alias")) {
          <button
            type="button"
            class="employee-executive-field__alert-button employee-executive-field__alert-button--field employee-executive-field__alert-button--error"
            aria-label="Ver error del alias"
            (click)="abrirErrorCampo('Alias')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        } @else {
          <button
            type="button"
            class="employee-executive-field__alert-button employee-executive-field__alert-button--field employee-executive-field__alert-button--info"
            aria-label="Información sobre el alias"
            (click)="abrirInfoAlias()"
          >
            <mat-icon>info_outline</mat-icon>
          </button>
        }

        @if (isInvalid("Alias")) {
          <small>{{ getError("Alias") }}</small>
        }
      </div>

      <div
        class="employee-executive-field employee-executive-field--password"
        [class.employee-executive-field--invalid]="isInvalid('Password')"
      >
        <label for="employee-executive-password">Contraseña*</label>
        <input
          id="employee-executive-password"
          name="atlas-reg-employee-executive-password"
          [type]="hidePassword ? 'password' : 'text'"
          formControlName="Password"
          placeholder="Ingresa tu contraseña"
          autocomplete="new-password"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false"
        />

        <span class="employee-executive-field__actions">
          <button
            type="button"
            class="employee-executive-field__icon-button"
            [attr.aria-label]="
              hidePassword ? 'Mostrar contraseña' : 'Ocultar contraseña'
            "
            (click)="hidePassword = !hidePassword"
          >
            <mat-icon>{{
              hidePassword ? "visibility_off" : "visibility"
            }}</mat-icon>
          </button>

          @if (validandoPassword) {
            <mat-icon
              class="employee-executive-field__status-icon employee-executive-field__status-icon--pending"
            >
              sync
            </mat-icon>
          } @else if (mostrarIconoPasswordCorrecto()) {
            <mat-icon
              class="employee-executive-field__status-icon employee-executive-field__status-icon--success"
            >
              check_circle
            </mat-icon>
          } @else if (mostrarIconoPasswordError()) {
            <button
              type="button"
              class="employee-executive-field__alert-button employee-executive-field__alert-button--error"
              aria-label="Ver reglas de contraseña"
              (click)="abrirErroresPassword()"
            >
              <mat-icon>error_outline</mat-icon>
            </button>
          } @else if (isInvalid("Password")) {
            <button
              type="button"
              class="employee-executive-field__alert-button employee-executive-field__alert-button--error"
              aria-label="Ver error de contraseña"
              (click)="abrirErrorCampo('Password')"
            >
              <mat-icon>error_outline</mat-icon>
            </button>
          }
        </span>

        @if (isInvalid("Password")) {
          <small>{{ getError("Password") }}</small>
        }
      </div>

      <div
        class="employee-executive-field employee-executive-field--password"
        [class.employee-executive-field--invalid]="
          isInvalid('ConfirmaPassword')
        "
      >
        <label for="employee-executive-confirm-password"
          >Confirma contraseña*</label
        >
        <input
          id="employee-executive-confirm-password"
          name="atlas-reg-employee-executive-confirm-password"
          [type]="hideConfirmPassword ? 'password' : 'text'"
          formControlName="ConfirmaPassword"
          placeholder="Confirma tu contraseña"
          autocomplete="new-password"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false"
        />

        <span class="employee-executive-field__actions">
          <button
            type="button"
            class="employee-executive-field__icon-button"
            [attr.aria-label]="
              hideConfirmPassword
                ? 'Mostrar confirmación'
                : 'Ocultar confirmación'
            "
            (click)="hideConfirmPassword = !hideConfirmPassword"
          >
            <mat-icon>{{
              hideConfirmPassword ? "visibility_off" : "visibility"
            }}</mat-icon>
          </button>

          @if (mostrarIconoConfirmaPasswordCorrecto()) {
            <mat-icon
              class="employee-executive-field__status-icon employee-executive-field__status-icon--success"
            >
              check_circle
            </mat-icon>
          } @else if (isInvalid("ConfirmaPassword")) {
            <button
              type="button"
              class="employee-executive-field__alert-button employee-executive-field__alert-button--error"
              aria-label="Ver error de confirmación"
              (click)="abrirErrorCampo('ConfirmaPassword')"
            >
              <mat-icon>error_outline</mat-icon>
            </button>
          }
        </span>

        @if (isInvalid("ConfirmaPassword")) {
          <small>{{ getError("ConfirmaPassword") }}</small>
        }
      </div>
    </div>
  </section>

  <section class="employee-executive-section">
    <header class="employee-executive-section__header">
      <mat-icon>verified_user</mat-icon>
      <h3>Verificación de contacto</h3>
    </header>

    <div
      class="employee-executive-contact-card"
      [class.employee-executive-contact-card--email-full]="!dosFaCorreoHabilitado"
      [class.employee-executive-contact-card--phone-full]="!dosFaTelefonoHabilitado"
    >
      <div
        class="employee-executive-field employee-executive-field--with-field-error"
        [class.employee-executive-field--invalid]="isInvalid('Email')"
      >
        <label for="employee-executive-email">Email*</label>
        <input
          id="employee-executive-email"
          name="atlas-reg-employee-executive-email"
          type="text"
          inputmode="email"
          formControlName="Email"
          placeholder="correo@ejemplo.com"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false"
          readonly
          (focus)="desbloquearAutofill($event)"
          (blur)="bloquearAutofill($event); verificarCorreoAlPerderFoco()"
          data-lpignore="true"
          data-1p-ignore="true"
          data-form-type="other"
        />

        @if (isInvalid("Email")) {
          <button
            type="button"
            class="employee-executive-field__alert-button employee-executive-field__alert-button--field employee-executive-field__alert-button--error"
            aria-label="Ver error del email"
            (mousedown)="$event.preventDefault()"
            (click)="abrirErrorCampo('Email')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        } @else if (
          formularioRegistro.controls.Email.value &&
          formularioRegistro.controls.Email.valid
        ) {
          <span
            class="employee-executive-field__status-action"
            role="status"
            aria-label="Correo electrónico válido"
          >
            <mat-icon
              class="employee-executive-field__status-icon employee-executive-field__status-icon--success"
            >
              check_circle
            </mat-icon>
          </span>
        }

        @if (isInvalid("Email")) {
          <small>{{ getError("Email") }}</small>
        }
      </div>

      <button
        type="button"
        class="employee-executive-verify-button"
        [class.employee-executive-verify-button--hidden]="!dosFaCorreoHabilitado"
        [class.employee-executive-verify-button--ok]="
          !dosFaCorreoHabilitado || validandoCorreo
        "
        [disabled]="
          consultandoNormaCorreo ||
          !dosFaCorreoHabilitado ||
          formularioRegistro.controls.Email.invalid ||
          procesandoCorreo ||
          validandoCorreo
        "
        (click)="verificarCorreo()"
      >
        <mat-icon
          [class.employee-executive-verify-button__icon--spin]="
            consultandoNormaCorreo || procesandoCorreo
          "
        >
          {{
            !dosFaCorreoHabilitado || validandoCorreo
              ? "check_circle"
              : consultandoNormaCorreo || procesandoCorreo
                ? "sync"
                : "mail"
          }}
        </mat-icon>
        @if (dosFaCorreoHabilitado) {
          <span>
            {{
              consultandoNormaCorreo
                ? "Consultando"
                : validandoCorreo
                  ? "Verificado"
                  : procesandoCorreo
                    ? "Enviando"
                    : "Click para verificar"
            }}
          </span>
        }
      </button>

      <div
        class="employee-executive-field employee-executive-field--phone employee-executive-field--with-field-error"
        [class.employee-executive-field--invalid]="isInvalid('Telefono')"
      >
        <label for="employee-executive-phone">Teléfono celular*</label>

        <div class="employee-executive-phone-control">
          <div
            class="employee-executive-phone-control__select-wrapper employee-executive-select employee-executive-select--compact"
          >
            <select
              class="employee-executive-phone-control__select employee-executive-select__control"
              aria-label="Código de país"
              [value]="codigoPaisTelefonoSeleccionadoKey"
              (change)="seleccionarCodigoPaisTelefono($event)"
            >
              @for (
                pais of codigosPaisTelefono;
                track getCodigoPaisTelefonoKey(pais)
              ) {
                <option [value]="getCodigoPaisTelefonoKey(pais)">
                  {{ pais.pais }} +{{ pais.codigo }}
                </option>
              }
            </select>
            <mat-icon class="employee-executive-select__chevron">
              keyboard_arrow_down
            </mat-icon>
          </div>

          <input
            id="employee-executive-phone"
            name="atlas-reg-employee-executive-phone"
            type="text"
            inputmode="numeric"
            [value]="telefonoLocal"
            maxlength="10"
            placeholder="10 dígitos"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="none"
            spellcheck="false"
            (focus)="desbloquearAutofill($event)"
            (input)="capturarTelefonoLocal($event)"
            (blur)="verificarTelefonoAlPerderFoco()"
            data-lpignore="true"
            data-1p-ignore="true"
            data-form-type="other"
            readonly
          />
        </div>

        @if (isInvalid("Telefono")) {
          <button
            type="button"
            class="employee-executive-field__alert-button employee-executive-field__alert-button--field employee-executive-field__alert-button--error"
            aria-label="Ver error del teléfono celular"
            (mousedown)="$event.preventDefault()"
            (click)="abrirErrorCampo('Telefono')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        } @else if (telefonoTieneFormatoCorrecto()) {
          <span
            class="employee-executive-field__status-action"
            role="status"
            aria-label="Teléfono celular válido"
          >
            <mat-icon
              class="employee-executive-field__status-icon employee-executive-field__status-icon--success"
            >
              check_circle
            </mat-icon>
          </span>
        }

        @if (isInvalid("Telefono")) {
          <small>{{ getError("Telefono") }}</small>
        }
      </div>

      <button
        type="button"
        class="employee-executive-verify-button"
        [class.employee-executive-verify-button--hidden]="!dosFaTelefonoHabilitado"
        [class.employee-executive-verify-button--ok]="
          !dosFaTelefonoHabilitado || validandoTelefono
        "
        [disabled]="!telefonoPuedeVerificarse()"
        (click)="verificarTelefono()"
      >
        <mat-icon
          [class.employee-executive-verify-button__icon--spin]="
            consultandoNormaTelefono || procesandoTelefono
          "
        >
          {{
            !dosFaTelefonoHabilitado || validandoTelefono
              ? "check_circle"
              : consultandoNormaTelefono || procesandoTelefono
                ? "sync"
                : "phone_iphone"
          }}
        </mat-icon>
        @if (dosFaTelefonoHabilitado) {
          <span>
            {{
              consultandoNormaTelefono
                ? "Consultando"
                : validandoTelefono
                  ? "Verificado"
                  : procesandoTelefono
                    ? "Enviando"
                    : "Click para verificar"
            }}
          </span>
        }
      </button>
    </div>
  </section>

  <section class="employee-executive-section">
    <header class="employee-executive-section__header">
      <mat-icon>vpn_key</mat-icon>
      <h3>Pregunta de seguridad</h3>
    </header>

    <div class="employee-executive-fields-card">
      <div
        class="employee-executive-field employee-executive-field--select-error"
        [class.employee-executive-field--invalid]="isInvalid('IdPregunta')"
      >
        <label for="employee-executive-question">Pregunta secreta*</label>
        <div class="employee-executive-select">
          <select
            id="employee-executive-question"
            class="employee-executive-select__control"
            formControlName="IdPregunta"
          >
            <option [ngValue]="null">Selecciona una pregunta</option>
            @for (pregunta of catPreguntas; track pregunta.Value) {
              <option [ngValue]="pregunta.Value">{{ pregunta.Text }}</option>
            }
          </select>
          <mat-icon class="employee-executive-select__chevron">
            keyboard_arrow_down
          </mat-icon>
        </div>

        @if (isInvalid("IdPregunta")) {
          <button
            type="button"
            class="employee-executive-field__alert-button employee-executive-field__alert-button--field employee-executive-field__alert-button--error"
            aria-label="Ver error de la pregunta secreta"
            (click)="abrirErrorCampo('IdPregunta')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid("IdPregunta")) {
          <small>{{ getError("IdPregunta") }}</small>
        }
      </div>

      <div
        class="employee-executive-field employee-executive-field--with-field-error"
        [class.employee-executive-field--invalid]="isInvalid('Respuesta')"
      >
        <label for="employee-executive-answer">Respuesta*</label>
        <input
          id="employee-executive-answer"
          name="atlas-reg-employee-executive-answer"
          type="text"
          formControlName="Respuesta"
          placeholder="Escribe tu respuesta"
          autocomplete="off"
          autocorrect="off"
          spellcheck="false"
        />

        @if (isInvalid("Respuesta")) {
          <button
            type="button"
            class="employee-executive-field__alert-button employee-executive-field__alert-button--field employee-executive-field__alert-button--error"
            aria-label="Ver error de la respuesta"
            (click)="abrirErrorCampo('Respuesta')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid("Respuesta")) {
          <small>{{ getError("Respuesta") }}</small>
        }
      </div>
    </div>
  </section>

  <section class="employee-executive-section">
    <header class="employee-executive-section__header">
      <mat-icon>person</mat-icon>
      <h3>Datos personales</h3>
    </header>

    <div class="employee-executive-fields-card">
      <div
        class="employee-executive-field employee-executive-field--with-field-error"
        [class.employee-executive-field--invalid]="isInvalid('Nombre')"
      >
        <label for="employee-executive-name">Nombre*</label>
        <input
          id="employee-executive-name"
          name="atlas-reg-employee-executive-name"
          type="text"
          formControlName="Nombre"
          placeholder="Ingresa tu nombre"
          autocomplete="given-name"
          autocorrect="off"
          spellcheck="false"
        />

        @if (isInvalid("Nombre")) {
          <button
            type="button"
            class="employee-executive-field__alert-button employee-executive-field__alert-button--field employee-executive-field__alert-button--error"
            aria-label="Ver error del nombre"
            (click)="abrirErrorCampo('Nombre')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid("Nombre")) {
          <small>{{ getError("Nombre") }}</small>
        }
      </div>

      <div
        class="employee-executive-field employee-executive-field--with-field-error"
        [class.employee-executive-field--invalid]="isInvalid('Paterno')"
      >
        <label for="employee-executive-paternal-name">Apellido paterno*</label>
        <input
          id="employee-executive-paternal-name"
          name="atlas-reg-employee-executive-paternal-name"
          type="text"
          formControlName="Paterno"
          placeholder="Ingresa tu apellido paterno"
          autocomplete="family-name"
          autocorrect="off"
          spellcheck="false"
        />

        @if (isInvalid("Paterno")) {
          <button
            type="button"
            class="employee-executive-field__alert-button employee-executive-field__alert-button--field employee-executive-field__alert-button--error"
            aria-label="Ver error del apellido paterno"
            (click)="abrirErrorCampo('Paterno')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid("Paterno")) {
          <small>{{ getError("Paterno") }}</small>
        }
      </div>

      <div
        class="employee-executive-field employee-executive-field--with-field-error"
        [class.employee-executive-field--invalid]="isInvalid('Materno')"
      >
        <label for="employee-executive-maternal-name">Apellido materno*</label>
        <input
          id="employee-executive-maternal-name"
          name="atlas-reg-employee-executive-maternal-name"
          type="text"
          formControlName="Materno"
          placeholder="Ingresa tu apellido materno"
          autocomplete="additional-name"
          autocorrect="off"
          spellcheck="false"
        />

        @if (isInvalid("Materno")) {
          <button
            type="button"
            class="employee-executive-field__alert-button employee-executive-field__alert-button--field employee-executive-field__alert-button--error"
            aria-label="Ver error del apellido materno"
            (click)="abrirErrorCampo('Materno')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid("Materno")) {
          <small>{{ getError("Materno") }}</small>
        }
      </div>

      <div
        class="employee-executive-field employee-executive-field--with-field-error"
        [class.employee-executive-field--invalid]="isInvalid('RFC')"
      >
        <label for="employee-executive-rfc">RFC*</label>
        <input
          id="employee-executive-rfc"
          name="atlas-reg-employee-executive-rfc"
          type="text"
          formControlName="RFC"
          placeholder="Ingresa tu RFC"
          maxlength="13"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="characters"
          spellcheck="false"
          (input)="capturarRfc($event)"
        />

        @if (isInvalid("RFC")) {
          <button
            type="button"
            class="employee-executive-field__alert-button employee-executive-field__alert-button--field employee-executive-field__alert-button--error"
            aria-label="Ver error del RFC"
            (click)="abrirErrorCampo('RFC')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid("RFC")) {
          <small>{{ getError("RFC") }}</small>
        }
      </div>
    </div>
  </section>

  <div class="employee-executive-actions">
    <button
      type="button"
      class="employee-executive-action employee-executive-action--secondary"
      [disabled]="loadingRegistro"
      (click)="regresar()"
    >
      Regresar
    </button>

    <button
      type="submit"
      class="employee-executive-action employee-executive-action--primary"
      [disabled]="loadingRegistro"
    >
      @if (loadingRegistro) {
        <mat-icon class="employee-executive-action__spinner">sync</mat-icon>
        <span>Registrando</span>
      } @else {
        <span>Continuar</span>
      }
    </button>
  </div>
</form>
